<template>
  <div class="other">
    <DataSatImg :DataSatImg="MateDatainfo"></DataSatImg>
        <!-- <Contact :Contact="MateDatainfo"></Contact> -->
    <Map :Geojson="MateDatainfo"></Map>

    <HotData :seenDataList="seenDataList"></HotData>
    <Recommend :otherdatalist="otherdatalist"></Recommend>
  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { dataList, datainfo, otherData, seenData } from "@/axios/datashare.js";
export default {
  name: "other",
  mixins: [mapMixin],
  props: ["MateDatainfo" ,'otherdatalist'],
  data() {
    return {
      dataId: null,
      seenDataList:null,
      otherdatalist:null
    };
  },
  mounted() {
    this.dataId = this.$route.query.dataId;
    this.getSeenData(this.dataId)
  },

  methods: {

    async getSeenData(dataId) {
      var res = await seenData(dataId);
      this.seenDataList = res.data.data;
      console.log(res);
    },
  },
  components: {
    TitleName: () => import("@/components/DataDetails/Other/TitleName.vue"),
    DataSatImg: () => import("@/components/DataDetails/Other/DataSatImg.vue"),
    Map: () => import("@/components/DataDetails/Other/Map.vue"),
    Contact: () => import("@/components/DataDetails/Other/Contact.vue"),
    HotData: () => import("@/components/DataDetails/Other/HotData.vue"),
    Recommend: () => import("@/components/DataDetails/Other/Recommend.vue"),
  },
};
</script>

<style lang="scss" scoped>
.other {
  flex: 1;
  margin-left: 10px;
  background: #fff;
  padding: 10px;
}
</style>